import React, { memo } from 'react';

import ExtraInterestMessage from './ExtraInterestMessage';

import { ExtraInterestTypes } from '../../../Enum/Interest/ExtraInterestProperties';
import { ExtraInterest } from '../../../Interface/Response/Interest/InterestPerProduct';
import { Interest } from '../../../Interface/Response/Interest/Interest';

import { hasValue } from '../../../Helpers/Interest/InterestHelper';

interface Props {
    extraInterest: ExtraInterest;
}

const ExtraInterestComponent: React.FC<Props> = ({ extraInterest }: Props) => {
    const {
        overbruggingskrediet,
        overbruggingskredietVariabel,
        krediethypotheek,
        krediethypotheekVariabel,
    } = extraInterest;

    const bridgingLoanFixedExists = hasValue(overbruggingskrediet);
    const bridgingLoanVariableExists = hasValue(overbruggingskredietVariabel);
    const creditLoanFixedExists = hasValue(krediethypotheek);
    const creditLoanVariableExists = hasValue(krediethypotheekVariabel);

    if (
        !bridgingLoanFixedExists
        && !bridgingLoanVariableExists
        && !creditLoanFixedExists
        && !creditLoanVariableExists
    ) {
        return null;
    }

    return (
        <>
            {(bridgingLoanFixedExists || bridgingLoanVariableExists) && (
                <div className="interest-message-wrapper">
                    <h6>Overbruggingskrediet</h6>
                    {bridgingLoanFixedExists && (
                        <ExtraInterestMessage
                            type={ExtraInterestTypes.FIXED}
                            interest={overbruggingskrediet as Interest}
                        />
                    )}
                    {bridgingLoanVariableExists && (
                        <ExtraInterestMessage
                            type={ExtraInterestTypes.VARIABLE}
                            interest={overbruggingskredietVariabel as Interest}
                        />
                    )}
                </div>
            )}
            {(creditLoanFixedExists || creditLoanVariableExists) && (
                <div className="interest-message-wrapper">
                    <h6>Krediethypotheek</h6>
                    {creditLoanFixedExists && (
                        <ExtraInterestMessage
                            type={ExtraInterestTypes.FIXED}
                            interest={krediethypotheek as Interest}
                        />
                    )}
                    {creditLoanVariableExists && (
                        <ExtraInterestMessage
                            type={ExtraInterestTypes.VARIABLE}
                            interest={krediethypotheekVariabel as Interest}
                        />
                    )}
                </div>
            )}
        </>
    );
};

export default memo(ExtraInterestComponent);
